import Collapse from "../../Collapse/Collapse"
import { useEffect, useState } from "react"
import { Link, NavLink, useLocation } from "react-router-dom"

function CustomIcon({ html }) {
  return <span dangerouslySetInnerHTML={{ __html: html || "" }} />
}

export default function Navbar({ items, footerItem, isNav, isMobile = false, onClose }) {
  const location = useLocation()

  useEffect(() => {
    if (isNav === "left-0") {
      document.body.style.overflow = "hidden"
    }
    return () => {
      document.body.style.overflow = null
    }
  }, [isNav])

  const wapperClass = isNav ? "show__sider" : "hide__sider"

  // Desktop thu gọn: flyout nằm ngoài 72px — cần z cao hơn section nội dung (không thì bị che hoàn toàn)
  const zSidebar = !isMobile && !isNav ? "z-[100]" : "z-12"

  return (
    <div
      className={`bg-base ${zSidebar} font-medium text-white h-screen top-0 shadow ease-in-out duration-300 flex flex-col ${wapperClass} ${isMobile ? "" : "sticky"} relative overflow-visible`}
    >
      {isMobile && isNav && (
        <button
          type="button"
          className="absolute top-3 right-3 z-[60] text-white/90 hover:text-white bg-white/10 hover:bg-white/20 rounded-full p-2"
          onClick={onClose}
          aria-label="Đóng menu"
          title="Đóng menu"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}
      <Link to="/staff/list" className={`flex items-center justify-center h-14 text-slate-50 shrink-0 ${isNav ? "px-4" : "px-2"}`} title="Bệnh viện ĐH Y Hà Nội">
        <span className={`font-semibold text-white uppercase text-center ${isNav ? "text-base" : "text-sm"} ${!isNav ? "leading-tight" : ""}`}>
          KSNK
        </span>
      </Link>
      <div
        className={`flex-1 min-h-0 flex flex-col ${isNav ? "overflow-y-auto __scroll" : "overflow-visible"}`}
      >
        <ul className={`flex flex-col py-4 space-y-2 overflow-visible ${!isNav ? "items-center px-0" : "px-4"}`}>
          {items.map((item) => {
            const { href, label, icon, children } = item
            if (children?.length > 0) {
              return <MenuItem {...item} key={href} location={location} isNav={isNav} />
            }
            const isActive = href === "/dashboard"
              ? location.pathname === "/dashboard"
              : location.pathname.includes(href)
            const activeClassName = isActive ? "bg-white/20 text-white" : "text-white/90"
            return (
              <li key={href} className={`list-none w-full ${!isNav ? "flex justify-center" : ""}`}>
                <NavLink to={href} title={!isNav ? label : undefined} className="block w-full">
                  <div className={`${activeClassName} menu__item flex items-center gap-4 ${!isNav ? "justify-center px-0" : ""}`}>
                    {icon}
                    {isNav && (
                      <span className="text-ellipsis flex-auto overflow-hidden whitespace-nowrap text-sm">
                        {label}
                      </span>
                    )}
                  </div>
                </NavLink>
              </li>
            )
          })}
        </ul>
      </div>
      {footerItem ? (
        <div className={`shrink-0 border-t border-white/15 ${isNav ? "px-4 py-3" : "px-0 py-3 flex justify-center"}`}>
          <NavLink
            to={footerItem.href}
            title={!isNav ? footerItem.label : undefined}
            className="block w-full"
            onClick={isMobile ? onClose : undefined}
          >
            {({ isActive }) => (
              <div
                className={`menu__item flex items-center gap-4 rounded ${
                  isActive ? "bg-white/20 text-white" : "text-white/90 hover:bg-white/10"
                } ${!isNav ? "justify-center px-0" : ""}`}
              >
                <CustomIcon html={footerItem.icon} />
                {isNav && (
                  <span className="text-ellipsis flex-auto overflow-hidden whitespace-nowrap text-sm">
                    {footerItem.label}
                  </span>
                )}
              </div>
            )}
          </NavLink>
        </div>
      ) : null}
    </div>
  )
}

function MenuItem({ label, icon, href, children, location, isNav }) {
  const [isOpen, setOpen] = useState(children.some((i) => location.pathname.includes(i.href)))
  const activeClassname = location.pathname.includes(href) ? "bg-white/10 text-white" : ""
  const classIsDown = isOpen ? "rotate-180" : "rotate-0"
  const icDown = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  )

  const subMenuContent = (
    <ul className="sider-submenu p-2 space-y-1 bg-white/10 rounded list-none m-0" role="menu">
      {children.map((sub) => (
        <li key={`${sub.href}-${href}`} role="none" className="list-none">
          <NavLink
            to={sub.href}
            end
            role="menuitem"
            className={({ isActive }) =>
              isActive
                ? "flex items-center text-white gap-2 py-2 px-3 rounded __active__sub__menu hover:text-white text-sm"
                : "flex items-center text-white/80 gap-2 py-2 px-3 rounded hover:text-white text-sm"
            }
          >
            <span className="h-1.5 w-1.5 bg-white/50 rounded-full __icon_sub shrink-0" aria-hidden />
            <span className="truncate">{sub.label}</span>
          </NavLink>
        </li>
      ))}
    </ul>
  )

  return (
    <li className={`list-none w-full ${!isNav ? "flex justify-center" : ""}`}>
      <div
        className="sub__menu relative text-sm group w-full"
        // Sidebar thu gọn: hover để xổ submenu; click cũng sẽ mở.
        onMouseEnter={() => {
          if (!isNav) setOpen(true)
        }}
        onMouseLeave={() => {
          if (!isNav) setOpen(false)
        }}
      >
        <div
          role="button"
          tabIndex={0}
          title={!isNav ? label : undefined}
          onClick={() => {
            if (!isNav) setOpen(true)
            else setOpen((c) => !c)
          }}
          onKeyDown={(e) => {
            if (e.key !== "Enter") return
            if (!isNav) setOpen(true)
            else setOpen((c) => !c)
          }}
          className={`${activeClassname} rounded cursor-pointer hover:bg-white/20 h-11 flex items-center min-w-0 ${isNav ? "px-4 justify-between gap-4" : "px-0 justify-center"}`}
        >
          <span className="shrink-0 flex items-center justify-center [&_svg]:w-6 [&_svg]:h-6">{icon}</span>
          {isNav && (
            <>
              <span className="text-ellipsis flex-auto overflow-hidden whitespace-nowrap text-sm">{label}</span>
              <span className={`shrink-0 ${classIsDown} flex items-center transition-transform duration-200`}>{icDown}</span>
            </>
          )}
        </div>
        {/* Sidebar mở: render sub-menu trực tiếp (không qua Collapse) để luôn thấy */}
        {isNav && isOpen && <div className="px-4 pt-0 pb-1">{subMenuContent}</div>}
        {/* Sidebar thu gọn: dùng Collapse làm flyout khi hover */}
        {!isNav && (
          <Collapse isOpen={isOpen} isShow={false}>
            {subMenuContent}
          </Collapse>
        )}
      </div>
    </li>
  )
}
